import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';

@Injectable({
  providedIn: 'root'
})
export class ZipCodeBackendServer extends BaseBackend {
  getZipCodes(builder) {
    return this.get('/zip-code', { params: builder });
  }

  getZipCode(zipCode) {
    return this.get(`/zip-code/${ zipCode }`)
  }

  saveZipCode(zipCodeData) {
    const { zipcode } = zipCodeData;
    if (zipcode._id) {
      return this.patch(`/zip-code/zipcode/${ zipcode }`, zipCodeData);
    }
    return this.post('/zip-code/zipcode', zipCodeData);
  }
}
